import { styled, keyframes } from '@stitchesConfig';
import { MdAutorenew } from 'react-icons/md';

export const StyledWarehouseList = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  gap: '$space16',
  position: 'relative',
  height: 'calc(100vh - 9.25rem)',
  borderRadius: '$radii8',
  overflowY: 'auto',
  padding: '$space1',

  '@lg': {
    height: 'calc(100vh - 12rem)',
  },
});

StyledWarehouseList.displayName = 'StyledWarehouseList';

export const StyledWarehouseCard = styled('div', {
  $$borderWidth: '$sizes$size1',
  $$borderColor: '$colors$gray7',
  boxShadow: '0 0 0 $$borderWidth $$borderColor, $md',
  display: 'flex',
  borderRadius: '$radii8',
  overflow: 'hidden',
  cursor: 'pointer',
  transition: 'box-shadow $fast, transform $fast',
  position: 'relative',

  '&:hover': {
    boxShadow: '0 0 0 $$borderWidth $$borderColor, $shadow',
    transform: 'scale(0.985)',
    // transform: 'scale(1.015)',
  },

  variants: {
    orientation: {
      vertical: {
        flexDirection: 'column',
        // width: '$size128',
        // height: '$size224',
      },
      horizontal: {
        flexDirection: 'row',
        // height: '$size128',

        // '@md': {
        //   maxHeight: '$size96',
        // },
      },
    },
  },
});

StyledWarehouseCard.displayName = 'StyledWarehouseCard';

export const StyledWarehouseCardImageContainer = styled('div', {
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',

  '@md': {
    width: '$size112',
  },
});

StyledWarehouseCardImageContainer.displayName =
  'StyledWarehouseCardImageContainer';

export const StyledWarehouseCardInfo = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$space8',
  width: '100%',
  padding: '$space16',
  backgroundColor: '$gray1',
  position: 'relative',

  variants: {
    orientation: {
      vertical: {
        borderTopWidth: '$sizes$size1',
        borderTopStyle: 'solid',
        borderTopColor: '$gray7',
      },
      horizontal: {
        borderLeftWidth: '$sizes$size1',
        borderLeftStyle: 'solid',
        borderLeftColor: '$gray7',
      },
    },
  },
});

StyledWarehouseCardInfo.displayName = 'StyledWarehouseCardInfo';

export const StyledWarehouseLoading = styled('div', {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$space16',
  borderRadius: '$radii8',
  backgroundColor: '$grayA11',
  color: '$gray1',

  '.dark-theme &': {
    $$borderWidth: '$sizes$size1',
    $$borderColor: '$colors$gray7',
    boxShadow: '0 0 0 $$borderWidth $$borderColor',
    backgroundColor: 'rgba(0 0 0 / 0.75)',
    color: '$gray12',
  },
});

StyledWarehouseLoading.displayName = 'StyledWarehouseLoading';

const spin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

export const StyledWarehouseLoadingIndicator = styled(MdAutorenew, {
  width: '4rem',
  height: '4rem',
  transform: 'rotate(-90deg)',
  animation: `${spin} 700ms linear infinite`,
});

StyledWarehouseLoadingIndicator.displayName = 'StyledWarehouseLoadingIndicator';
